import { useEffect, useRef, useState } from 'react';
import posthog from 'posthog-js';

const IDLE_TIMEOUT = 300000; // 5 minutes (in milliseconds)

export const useIdleTracker = () => {
  const idleTimer = useRef(null);
  const lastActiveTime = useRef(Date.now());
  const [isIdle, setIsIdle] = useState(false);

  const resetTimer = () => {
    clearTimeout(idleTimer.current);
    lastActiveTime.current = Date.now();
    if (isIdle) {
      setIsIdle(false);
      posthog.capture('user_returned_from_idle');
    }
    idleTimer.current = setTimeout(() => {
      const idleDuration = Date.now() - lastActiveTime.current;
      setIsIdle(true);
      posthog.capture('user_idle', {
        idle_duration_ms: idleDuration,
      });
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'scroll', 'click'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer(); // start the timer

    return () => {
      clearTimeout(idleTimer.current);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, []);
};
